<div class="container h-100 align-items-center canvas-page">
  <div *ngIf="isLoading" class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
  <div class="row justify-content-center align-items-center VerticalMargin mb-5" *ngIf="isLoading == false">
    <div class="card RegularForm rounded col-12 col-xs-9 col-lg-8 canvas-panel"
      [class.SmallArabicFont]="globalService.isRTL == true">
      <div class="card-body MyCardBody rounded-bottom">
        <div>
          <div class="row mb-5" *ngIf="
          forms.length == 0
          ">
            <div class="col-12 text-center text-dark" [class.SmallArabicFont]="globalService.isRTL == true">
              <app-empty-state kind="forms"></app-empty-state>
            </div>
          </div>
          <div class="entity-navigation-item" *ngFor="let form of forms">
            <button class="btn btn-block btn-outline-primary text-left entity-navigation-button" type="button" (click)="gotoForm(form.id)">
              <span [class.SmallArabicFont]="globalService.isRTL == true">
                {{ form.name | resourceLabel:form:'name' }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>